var map = {
	"./a.-philip-randolph.png": "912d",
	"./abraham-doras-shadd.png": "a85a",
	"./abraham-lincoln.png": "d0a5",
	"./cecil-calvert.png": "6321",
	"./charles-calvert.png": "e45d",
	"./charles-hamilton-houston.png": "7789",
	"./dred-scott.png": "a848",
	"./dwight-d.-eisenhower.png": "51b0",
	"./elizabeth-cady-stanton.png": "b662",
	"./ernest-green.png": "5900",
	"./father-andrew-white.png": "0f68",
	"./frances-ellen-watkins-harper.png": "eb5a",
	"./frederick-douglass.png": "f37f",
	"./george-calvert.png": "f1a5",
	"./harriet-beecher-stowe.png": "7b15",
	"./harriet-tubman.png": "a946",
	"./harry-s.-truman.png": "e21a",
	"./henry-fleet.png": "281e",
	"./homer-plessy.png": "a529",
	"./hosea-williams.png": "411f",
	"./james-nabrit-jr..png": "1a0c",
	"./john-babtist.png": "31af",
	"./john-f.-kennedy.png": "7b9e",
	"./john-lewis.png": "53f1",
	"./justice-john-marshall-harlan.png": "4fdb",
	"./king-charles-i-and-queen-henrietta-maria.png": "d8b5",
	"./king-charles-i.png": "da8a",
	"./leonard-calvert.png": "6800",
	"./louis-l.-redding.png": "0497",
	"./lyndon-b.-johnson.png": "fdbe",
	"./margaret-brent.png": "8209",
	"./mary-ann-shadd-cary.png": "652c",
	"./mary-church-terrell.png": "83d6",
	"./mathias-de-sousa.png": "caf3",
	"./nat-turner.png": "64eb",
	"./placeholder1/abraham-doras-shadd.png": "0c4f",
	"./placeholder1/african-grand-lodge.png": "917d0",
	"./placeholder1/andrew-jackson.png": "5b37",
	"./placeholder1/andrew-johnson.png": "106b",
	"./placeholder1/anna-dickinson.png": "7ac6",
	"./placeholder1/benjamin-franklin-palmer.png": "76f8",
	"./placeholder1/benjamin-lundy.png": "9ff0",
	"./placeholder1/betsy-ross.png": "7965",
	"./placeholder1/bishop-henry-mcneal-turner.png": "739c",
	"./placeholder1/british-admiral-richard-howe.png": "15e8",
	"./placeholder1/carl-shurz.png": "ff46",
	"./placeholder1/charles-sumner.png": "731e",
	"./placeholder1/charles-thomson.png": "d494",
	"./placeholder1/cherokee.png": "57d5",
	"./placeholder1/cherry-turner.png": "42ae",
	"./placeholder1/choctaw.png": "2748",
	"./placeholder1/clara-barton.png": "b97d",
	"./placeholder1/commodore-george-dewey.png": "542f",
	"./placeholder1/cornelius-van-drebel.png": "60eb",
	"./placeholder1/david-bushnell.png": "c6ba",
	"./placeholder1/david-ruggles.png": "55fb",
	"./placeholder1/david-walker.png": "1fc9",
	"./placeholder1/dorethea-dix.png": "0c26",
	"./placeholder1/dred-sam-scott.png": "755c",
	"./placeholder1/edward-g.-walker.png": "a270",
	"./placeholder1/emily-blackwell.png": "fddd",
	"./placeholder1/ezra-cornell.png": "bcff",
	"./placeholder1/ezra-lee.png": "90d3",
	"./placeholder1/fickett-&-crockett.png": "dec1",
	"./placeholder1/frances-willard.png": "d4c8",
	"./placeholder1/frank-emory-bunts.png": "acfd",
	"./placeholder1/general-ambrose-burnside.png": "8ce0",
	"./placeholder1/general-henry-huidekoper.png": "aa57",
	"./placeholder1/general-henry-s.-huidekoper.png": "7dd4",
	"./placeholder1/george-dewey.png": "6a5d",
	"./placeholder1/george-jones.png": "db2e",
	"./placeholder1/george-opdyke.png": "a5b8",
	"./placeholder1/george-thompson.png": "9c19",
	"./placeholder1/george-washington.png": "caee",
	"./placeholder1/gettysburg-national-park-commission.png": "7122",
	"./placeholder1/governor-horatio-seymour.png": "a0ea",
	"./placeholder1/gustav-weber.png": "8f2a",
	"./placeholder1/henry-ford.png": "eb9d",
	"./placeholder1/henry-fox-talbot.png": "0ac4",
	"./placeholder1/henry-jarvis-raymond.png": "4643",
	"./placeholder1/hippolyte-auguste-marinoni.png": "33d6",
	"./placeholder1/hércules-florence.png": "3629",
	"./placeholder1/ida-bell-wells-barnett.png": "93b8",
	"./placeholder1/irish-immigrants.png": "0e85",
	"./placeholder1/james-penington.png": "debe",
	"./placeholder1/jane-johnson.png": "4a9f",
	"./placeholder1/jane-stuart-woolsey.png": "3936",
	"./placeholder1/john-hooker.png": "9b05",
	"./placeholder1/john-tyler.png": "2363",
	"./placeholder1/joseph-lister.png": "32eb",
	"./placeholder1/josiah-henson.png": "2f9f",
	"./placeholder1/katherine-prescott-wormeley.png": "9682",
	"./placeholder1/letitia-still.png": "12b4",
	"./placeholder1/louis-pasteur.png": "5be6",
	"./placeholder1/louisa-may-alcott.png": "e561",
	"./placeholder1/lucretia-mott.png": "ae49",
	"./placeholder1/lucy-stone.png": "a5ea",
	"./placeholder1/lyman-beecher.png": "79fd",
	"./placeholder1/malcom-x.png": "2401",
	"./placeholder1/martha-coffin-wright.png": "eb5ad",
	"./placeholder1/morse-and-vail.png": "9ddb",
	"./placeholder1/moses-rogers.png": "9c0f",
	"./placeholder1/moses-yale-beach.png": "7979",
	"./placeholder1/nat-turner.png": "05de",
	"./placeholder1/nathan-bedford-forrest.png": "6a86",
	"./placeholder1/national-association-of-colored-women.png": "c336",
	"./placeholder1/nicéphore-niépce.png": "0a83",
	"./placeholder1/pascual-cervera.png": "2e95",
	"./placeholder1/pennsylvania-anti-slavery-society.png": "565d",
	"./placeholder1/philadelphia-brigade.png": "a72c",
	"./placeholder1/president-polk.png": "2d75",
	"./placeholder1/redelia-bates.png": "7530",
	"./placeholder1/richard-march-hoe.png": "ddeb",
	"./placeholder1/rt.-rev.-richard-allen.png": "59f0",
	"./placeholder1/sarah-p-wills.png": "0e3e",
	"./placeholder1/seminole.png": "6f2d",
	"./placeholder1/sir-john-herschel.png": "8402",
	"./placeholder1/ss-savanah.png": "dad9",
	"./placeholder1/stephen-a-douglass.png": "1bb5",
	"./placeholder1/susie-king-taylor.png": "6df8",
	"./placeholder1/thaddeus-stevens.png": "f0c8",
	"./placeholder1/thomas-cary.png": "cf50",
	"./placeholder1/thomas-edison.png": "d13d",
	"./placeholder1/thomas-garrett.png": "455e",
	"./placeholder1/thomas-gray.png": "4d00",
	"./placeholder1/victor-lawson.png": "48a5",
	"./placeholder1/vincent-colyer.png": "b41d",
	"./placeholder1/william-henry-johnson.png": "684b",
	"./placeholder1/william-howard-taft.png": "0516",
	"./placeholder1/william-mckinley.png": "edb1",
	"./placeholder1/william-still.png": "0196",
	"./placeholder1/william-wells-brown.png": "8a55",
	"./placeholder1/zachary-taylor.png": "1cff",
	"./placeholder2/abraham-doras-shadd.png": "d483",
	"./placeholder2/african-grand-lodge.png": "1ae6",
	"./placeholder2/andrew-jackson.png": "6cd4",
	"./placeholder2/andrew-johnson.png": "8a29",
	"./placeholder2/anna-dickinson.png": "7041",
	"./placeholder2/benjamin-franklin-palmer.png": "ff00",
	"./placeholder2/benjamin-lundy.png": "c463",
	"./placeholder2/betsy-ross.png": "b4fb",
	"./placeholder2/bishop-henry-mcneal-turner.png": "0143",
	"./placeholder2/british-admiral-richard-howe.png": "996f",
	"./placeholder2/carl-shurz.png": "c03e",
	"./placeholder2/charles-sumner.png": "6aa5",
	"./placeholder2/charles-thomson.png": "d759",
	"./placeholder2/cherokee.png": "4c73",
	"./placeholder2/cherry-turner.png": "eacc",
	"./placeholder2/choctaw.png": "aebc",
	"./placeholder2/clara-barton.png": "8978",
	"./placeholder2/commodore-george-dewey.png": "ad61",
	"./placeholder2/cornelius-van-drebel.png": "e733",
	"./placeholder2/david-bushnell.png": "5292",
	"./placeholder2/david-ruggles.png": "9535",
	"./placeholder2/david-walker.png": "1dd4",
	"./placeholder2/dorethea-dix.png": "eaae",
	"./placeholder2/dred-sam-scott.png": "4966",
	"./placeholder2/edward-g.-walker.png": "dc60",
	"./placeholder2/emily-blackwell.png": "432a",
	"./placeholder2/ezra-cornell.png": "9a64",
	"./placeholder2/ezra-lee.png": "99a4",
	"./placeholder2/fickett-&-crockett.png": "bfd0",
	"./placeholder2/frances-willard.png": "e54c",
	"./placeholder2/frank-emory-bunts.png": "fc1a",
	"./placeholder2/general-ambrose-burnside.png": "f598",
	"./placeholder2/general-henry-huidekoper.png": "35ed",
	"./placeholder2/general-henry-s.-huidekoper.png": "eea5",
	"./placeholder2/george-dewey.png": "eb80",
	"./placeholder2/george-jones.png": "d442",
	"./placeholder2/george-opdyke.png": "fbd5",
	"./placeholder2/george-thompson.png": "b552",
	"./placeholder2/george-washington.png": "bed3",
	"./placeholder2/gettysburg-national-park-commission.png": "ed3c",
	"./placeholder2/governor-horatio-seymour.png": "67c6",
	"./placeholder2/gustav-weber.png": "7b57",
	"./placeholder2/henry-ford.png": "9918",
	"./placeholder2/henry-fox-talbot.png": "3409",
	"./placeholder2/henry-jarvis-raymond.png": "230c",
	"./placeholder2/hippolyte-auguste-marinoni.png": "ff92",
	"./placeholder2/hércules-florence.png": "f7f7",
	"./placeholder2/ida-bell-wells-barnett.png": "06b1",
	"./placeholder2/irish-immigrants.png": "449b",
	"./placeholder2/james-penington.png": "44a9",
	"./placeholder2/jane-johnson.png": "8b66",
	"./placeholder2/jane-stuart-woolsey.png": "d86e",
	"./placeholder2/john-hooker.png": "300a",
	"./placeholder2/john-tyler.png": "b06b",
	"./placeholder2/joseph-lister.png": "5609",
	"./placeholder2/josiah-henson.png": "9010",
	"./placeholder2/katherine-prescott-wormeley.png": "ed86",
	"./placeholder2/letitia-still.png": "0cb8",
	"./placeholder2/louis-pasteur.png": "2053",
	"./placeholder2/louisa-may-alcott.png": "c8f8",
	"./placeholder2/lucretia-mott.png": "6003",
	"./placeholder2/lucy-stone.png": "de1d",
	"./placeholder2/lyman-beecher.png": "20f1",
	"./placeholder2/malcom-x.png": "a7b5",
	"./placeholder2/martha-coffin-wright.png": "9b88",
	"./placeholder2/morse-and-vail.png": "05c7",
	"./placeholder2/moses-rogers.png": "941b",
	"./placeholder2/moses-yale-beach.png": "a056",
	"./placeholder2/nat-turner.png": "773e",
	"./placeholder2/nathan-bedford-forrest.png": "d8e8",
	"./placeholder2/national-association-of-colored-women.png": "8be3",
	"./placeholder2/nicéphore-niépce.png": "b0c3",
	"./placeholder2/pascual-cervera.png": "6f59",
	"./placeholder2/pennsylvania-anti-slavery-society.png": "8894",
	"./placeholder2/philadelphia-brigade.png": "4cc3",
	"./placeholder2/president-polk.png": "64c9",
	"./placeholder2/redelia-bates.png": "2a26",
	"./placeholder2/richard-march-hoe.png": "6588",
	"./placeholder2/rt.-rev.-richard-allen.png": "2738",
	"./placeholder2/sarah-p-wills.png": "a420",
	"./placeholder2/seminole.png": "8961",
	"./placeholder2/sir-john-herschel.png": "696f",
	"./placeholder2/ss-savanah.png": "06a2",
	"./placeholder2/stephen-a-douglass.png": "e80a",
	"./placeholder2/susie-king-taylor.png": "f814",
	"./placeholder2/thaddeus-stevens.png": "6642",
	"./placeholder2/thomas-cary.png": "cea5",
	"./placeholder2/thomas-edison.png": "055d",
	"./placeholder2/thomas-garrett.png": "0e10",
	"./placeholder2/thomas-gray.png": "b0f9",
	"./placeholder2/victor-lawson.png": "8956",
	"./placeholder2/vincent-colyer.png": "f437",
	"./placeholder2/william-henry-johnson.png": "4b11",
	"./placeholder2/william-howard-taft.png": "41fb",
	"./placeholder2/william-mckinley.png": "46e2",
	"./placeholder2/william-still.png": "d45c",
	"./placeholder2/william-wells-brown.png": "6794",
	"./placeholder2/zachary-taylor.png": "ef93",
	"./president-dwight-d.-eisenhower.png": "cd00",
	"./president-harry-s-truman.png": "5e40",
	"./president-john-f.-kennedy.png": "bf9b",
	"./queen-henrietta-maria.png": "6fe3",
	"./rev.-dr.-martin-luther-king,-jr..png": "ae47",
	"./richard-ingle.png": "8c9e",
	"./sojourner-truth.png": "1104",
	"./susan-b-anthony.png": "11d1",
	"./thurgood-marshall.png": "4763",
	"./wannas-the-tayac.png": "3c1f",
	"./william-claiborne.png": "8178",
	"./william-lloyd-garrison.png": "e553",
	"./william-seward.png": "ad64",
	"./william-still.png": "525a",
	"./william-stone.png": "a960"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "160a";